'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleIframeResize = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleIframeResize = exports.handleIframeResize = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.IFRAME_RESIZE);